import React, { FC } from 'react';

interface Props {
    commonProps: Record<string, unknown>;
    componentModules: { [key: string]: FC };
    cellWidth?: number;
}

export const ComponentGrid = ({
    cellWidth = 200,
    commonProps,
    componentModules,
}: Props): JSX.Element => {
    const Components = [] as FC[];

    // eslint-disable-next-line guard-for-in
    for (const key in componentModules) {
        const componentModule = componentModules[key];

        Components.push(componentModule);
    }

    return (
        <div
            style={{
                display: 'grid',
                gridTemplateColumns: `repeat(auto-fill, minmax(${cellWidth}px, 1fr))`,
                gridGap: '2rem',
            }}
        >
            {Components.map(
                (Component: FC): JSX.Element => (
                    <div
                        key={Component.name}
                        className="flex flex-col justify-between"
                    >
                        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                        <Component {...commonProps} />
                        <div className="break-words text-sm">
                            {Component.name}
                        </div>
                    </div>
                ),
            )}
        </div>
    );
};
